var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"button button--secondary",on:{"mousedown":_vm.mousedownTrigger,"click":function($event){return _vm.$emit('click')}}},'button',_vm.$attrs,false),[_vm._t("default"),_c('span',{staticClass:"ripple",style:(_vm.classWidth)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }